import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const api = axios.create({ baseURL: API, withCredentials: true });

let refreshing = null;
api.interceptors.response.use(
  (r) => r,
  async (err) => {
    const cfg = err.config;
    const url = cfg?.url || "";
    if (err.response?.status === 401 && !cfg._retry && !url.includes("/auth/")) {
      cfg._retry = true;
      try {
        refreshing = refreshing || api.post("/auth/refresh");
        await refreshing;
        refreshing = null;
        return api(cfg);
      } catch (e) {
        refreshing = null;
        window.dispatchEvent(new Event("roxy:logout"));
      }
    }
    return Promise.reject(err);
  }
);

export function errMsg(e) {
  const d = e?.response?.data?.detail;
  if (d == null) return e?.message || "Something went wrong. Please try again.";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => (x && typeof x.msg === "string" ? x.msg.replace("Value error, ", "") : JSON.stringify(x))).join(" ");
  if (d && typeof d.msg === "string") return d.msg;
  return String(d);
}

export async function download(path, filename) {
  let res;
  try {
    res = await api.get(path, { responseType: "blob" });
  } catch (e) {
    const b = e?.response?.data;
    if (b instanceof Blob) {
      try { e.response.data = JSON.parse(await b.text()); } catch (x) { /* not json */ }
    }
    throw e;
  }
  const url = URL.createObjectURL(res.data);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  a.click();
  setTimeout(() => URL.revokeObjectURL(url), 2000);
}

export async function openAttachment(id) {
  const res = await api.get(`/attachments/${id}/download`, { responseType: "blob" });
  const url = URL.createObjectURL(res.data);
  window.open(url, "_blank");
}

export const fmtQty = (v, uom = "m") =>
  `${Number(v || 0).toLocaleString("en-IN", { maximumFractionDigits: 3 })} ${uom}`;
export const fmtINR = (v) =>
  v == null ? "—" : `${Number(v) < 0 ? "−" : ""}₹${Math.abs(Number(v)).toLocaleString("en-IN", { maximumFractionDigits: 0 })}`;
export const fmtDT = (s) =>
  s ? new Date(s).toLocaleString("en-IN", { timeZone: "Asia/Kolkata", day: "2-digit", month: "short", year: "numeric", hour: "2-digit", minute: "2-digit" }) : "—";
export const todayIST = () => new Date(Date.now() + 5.5 * 3600 * 1000).toISOString().slice(0, 10);
export const TXN_LABELS = {
  opening_stock: "Opening Stock", purchase_receipt: "Purchase Receipt", cutting: "Cutting", cut_piece: "Cut Piece",
  reservation: "Reservation", dispatch: "Dispatch", return: "Return", transfer: "Internal Transfer", scrap: "Scrap",
  adjustment: "Adjustment", reversal: "Reversal",
};
